import React from 'react';

import { ADMIN_WORKFLOWS } from '@ApplicationWide/permissions/constants';
import { WORKFLOWS_PATH } from '@ApplicationWide/routes/admin/admin-urls';

const EditWorkflowPage = React.lazy(() => import('../../../pages/Admin/ManageWorkflows/EditWorkflowPage'));

export default {
  route: [`${WORKFLOWS_PATH}/edit/:id`],
  area: ADMIN_WORKFLOWS,
  component: EditWorkflowPage,
  requiredRoles: ['admin', 'super_admin'],
  adminVisibilityPermission: ADMIN_WORKFLOWS,
  hasNavBar: true,
};
